<script setup lang="ts">
import SkeletonLoader from '@/components/base/skeleton/SkeletonLoader.vue'
</script>
<template>
  <div w-full flex="~ col" my-8>
    <SkeletonLoader my-2 class="w-full h-6" />
    <SkeletonLoader my-2 class="w-full h-6" />
    <SkeletonLoader my-2 class="w-full h-6" />
    <SkeletonLoader my-2 class="w-full h-6" />
    <SkeletonLoader my-2 class="w-8/12 h-6" />

    <SkeletonLoader mb-2 mt-4 class="w-full h-6" />
    <SkeletonLoader my-2 class="w-6/12 h-6" />

    <SkeletonLoader my-8 class="w-42 h-8" />
    <SkeletonLoader my-2 class="w-full h-6" />
    <SkeletonLoader my-2 class="w-6/12 h-6" />
    <div w-full flex="~ row" items-center mt-8>
      <SkeletonLoader type="circle" mr-3 h-8 w-8 />
      <div flex="~ col" grow>
        <div flex="~ row" items-baseline text-sm>
          <SkeletonLoader class="w-30 h-4" pt-0.5 />
          <SkeletonLoader class="w-12 h-4" ml-2 />
        </div>
        <SkeletonLoader class="w-24 h-4" mt-2 />
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped></style>
